// Kicks off a browser download for a (signed) URL. The S3 response sets
// Content-Disposition, so a plain anchor click downloads the file instead
// of navigating away.
export const triggerBrowserDownload = (url: string): void => {
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.rel = "noopener";
  // Let the server's Content-Disposition decide the filename.
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  try {
    anchor.click();
  } finally {
    // Always clean up, even if click() throws in some browsers.
    document.body.removeChild(anchor);
  }
};
